import { render, staticRenderFns } from "./PortingCancelationReasons.vue?vue&type=template&id=9c908712&scoped=true&"
import script from "./PortingCancelationReasons.vue?vue&type=script&lang=js&"
export * from "./PortingCancelationReasons.vue?vue&type=script&lang=js&"
import style0 from "./PortingCancelationReasons.vue?vue&type=style&index=0&id=9c908712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c908712",
  null
  
)

export default component.exports